export function getBaseNameFromUrl(urlString) {
  try {
    const { pathname } = new URL(urlString)
    const lastSegment = pathname.split('/').filter(Boolean).pop()
    if (!lastSegment) return undefined

    return lastSegment.replace(/\.[^.]+$/, '')
  } catch {
    return undefined
  }
}
